import React from 'react';
import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogTitle,
} from 'src/@/components/ui/dialog';
import { Input } from 'src/@/components/ui/input';
import { Button } from 'src/@/components/ui/button';
import { Label } from 'src/@/components/ui/label';
import Iconify from 'src/components/Iconify';

import { MAKE_DESIGN as d } from '../Make.design';

const ModalAddMake = ({
    openWebhook,
    nome,
    setNome,
    url,
    setUrl,
    isEdit,
    loading,
    onEdit,
    onCreate,
    onClose,
}) => {
    return (
        <Dialog open={openWebhook} onOpenChange={onClose}>
            <DialogContent className={d.modal.content}>
                {/* Header */}
                <div className={d.modal.header.container}>
                    <div className={d.modal.header.iconRow}>
                        <div
                            className={`${d.modal.header.iconBox} ${
                                isEdit ? d.modal.header.iconEdit : d.modal.header.iconCreate
                            }`}
                        >
                            <Iconify
                                icon={isEdit ? 'eva:edit-2-outline' : 'eva:plus-outline'}
                                width={18}
                            />
                        </div>
                        <div>
                            <DialogTitle className={d.modal.header.title}>
                                {isEdit ? 'Editar' : 'Nova'} credencial
                            </DialogTitle>
                            <DialogDescription className={d.modal.header.subtitle}>
                                {isEdit
                                    ? 'Altere os dados da credencial Make'
                                    : 'Configure uma nova credencial para o Make'}
                            </DialogDescription>
                        </div>
                    </div>
                </div>

                {/* Body */}
                <div className={d.modal.body}>
                    <div className="grid gap-2">
                        <Label htmlFor="nome" className={d.modal.label}>
                            Nome
                        </Label>
                        <Input
                            id="nome"
                            autoFocus
                            value={nome}
                            onChange={(e) => setNome(e.target.value)}
                            placeholder="Ex: Integração CRM"
                            className={d.modal.input}
                        />
                    </div>
                    <div className="grid gap-2">
                        <Label htmlFor="url" className={d.modal.label}>
                            URL do Webhook
                        </Label>
                        <Input
                            id="url"
                            value={url}
                            onChange={(e) => setUrl(e.target.value)}
                            placeholder="https://hook.make.com/..."
                            className={d.modal.input}
                        />
                    </div>
                </div>

                {/* Footer */}
                <div className={d.modal.footer}>
                    <Button variant="ghost" onClick={onClose}>
                        Cancelar
                    </Button>
                    <Button
                        onClick={isEdit ? onEdit : onCreate}
                        disabled={loading}
                        className="bg-[#7C3AED] hover:bg-[#6d28d9] text-white"
                    >
                        {isEdit ? 'Salvar alterações' : 'Criar credencial'}
                    </Button>
                </div>
            </DialogContent>
        </Dialog>
    );
};

export default ModalAddMake;
